import { FETCH_LIMIT_LOW, FETCH_LIMIT_MIDDLE, FIRST_PAGE } from '../../../../../../const/Page';
import { FunctionType, PermissionType } from '../../../../../../const/UserPermission';
import {
  InstructorPracticeSubmitSearchType,
  PracticeDetailFragment,
  PracticeSubmitSearchType,
  PracticeSubmitSortKey,
  QuestionSearchType,
  QuestionSortKey,
  useGetPracticeQuery,
  useGetPracticeSubmitsForInstructorQuery,
  useGetPracticeSubmitsQuery,
  useGetQuestionsQuery,
} from '../../../../../../gen/graphql';

/* eslint-disable @typescript-eslint/no-namespace */
export namespace PracticeDetailFunctions {
  export function getPermissions(permissionCheck: (functionType: string, permissionType: string) => boolean) {
    return {
      practiceForInstructorAndCoachRead: permissionCheck(
        FunctionType.PracticeForInstructorAndCoach,
        PermissionType.Read,
      ),
      programForInstructorAndCoachRead: permissionCheck(FunctionType.ProgramForInstructorAndCoach, PermissionType.Read),
      questionCreate: permissionCheck(FunctionType.Question, PermissionType.Create),
      recommendLightRead: permissionCheck(FunctionType.RecommendLight, PermissionType.Read),
      recommendTeamSubscriptionRead: permissionCheck(FunctionType.RecommendTeamSubscription, PermissionType.Read),
      recommendTeamSubscriptionToAdminRead: permissionCheck(
        FunctionType.RecommendTeamSubscriptionToAdmin,
        PermissionType.Read,
      ),
    } as const;
  }

  export function useGetPractice(
    practiceID: string,
    onCompleted?: (practice: PracticeDetailFragment | null | undefined) => void,
  ): ReturnType<typeof useGetPracticeQuery> {
    return useGetPracticeQuery({
      variables: {
        practiceID: practiceID,
      },
      onCompleted: (data) => {
        onCompleted?.(data.practice);
      },
    });
  }

  export function useGetQuestions(practiceID: string): ReturnType<typeof useGetQuestionsQuery> {
    return useGetQuestionsQuery({
      variables: {
        input: {
          type: QuestionSearchType.All,
          page: FIRST_PAGE,
          limit: FETCH_LIMIT_MIDDLE,
          practiceID: practiceID,
          sortKey: QuestionSortKey.CreatedAt,
        },
      },
    });
  }

  export function useGetPracticeSubmits(
    practiceID: string,
    skip: boolean,
  ): ReturnType<typeof useGetPracticeSubmitsQuery> {
    return useGetPracticeSubmitsQuery({
      variables: {
        input: {
          type: PracticeSubmitSearchType.All,
          practiceID: practiceID,
          sortKey: PracticeSubmitSortKey.CreatedAt,
          page: FIRST_PAGE,
          limit: FETCH_LIMIT_LOW,
        },
      },
      skip: skip,
      notifyOnNetworkStatusChange: true,
    });
  }

  export function useGetPracticeSubmitsForInstructor(
    practiceID: string,
    skip: boolean,
  ): ReturnType<typeof useGetPracticeSubmitsForInstructorQuery> {
    return useGetPracticeSubmitsForInstructorQuery({
      variables: {
        input: {
          type: InstructorPracticeSubmitSearchType.All,
          practiceID: practiceID,
          sortKey: PracticeSubmitSortKey.CreatedAt,
          page: FIRST_PAGE,
          limit: FETCH_LIMIT_LOW,
        },
      },
      skip: skip,
      notifyOnNetworkStatusChange: true,
    });
  }
}
